import { AuthLevel, generateBaseApiContext } from '@guiker/react-framework'
import { AdminApiClient } from '@guiker/user-shared'

export * from './UserContext'

export const {
  useContext: useAdminUserContext,
  Context: AdminUserContext,
  ContextProvider: AdminUserContextProvider,
  NestedRouter: AdminUserNestedRouter,
} = generateBaseApiContext({
  authLevel: AuthLevel.ADMIN,
  apiClientGen: AdminApiClient,
  cacheKey: ({ userId }: { userId: string }) => `readOneUser-${userId}`,
  fetcher: (apiClient, { userId }: { userId: string }) => apiClient.readOneUser({ pathParams: { userId } }),
})
